import React from 'react';
import type { ReactElement } from 'react';
import { count } from '@wordpress/wordcount';
import Grid from 'atom-components/grid';
import Heading from 'atom-components/heading';
import MarkItem from 'feature-components/mark-response/mark-response-form/fields/mark-item';
import SanitisedAnswer, { sanitiseAnswer } from 'feature-components/sanitised-answer';
import type { UiQuestion } from 'hooks/marking/ui-categories-builder';
import type { AuthorisableMark } from 'policies/entities/mark';
import type { MarkResponseFormValues } from './mark-response-form.schema';
import styles from './question.module.scss';

type Props = {
  question: UiQuestion;
  showHeading: boolean;
  authorisableMark: AuthorisableMark;
  defaultValues: MarkResponseFormValues;
};

export function wordCount(submittedValue: string): string {
  return count(sanitiseAnswer(submittedValue));
}

export default function Question({
  question,
  showHeading,
  authorisableMark,
  defaultValues
}: Props): ReactElement {
  return (
    <div key={question.id}>
      {showHeading && <Heading level={4}>{question.name}</Heading>}
      <div className={styles.questionRubricWrapper}>
        {question.responseItems.map((responseItem) => (
          <div key={responseItem.id} className={styles.questionWrapper}>
            <SanitisedAnswer
              className={styles.question}
              unsanitisedAnswer={responseItem.submittedValue}
            />
            <div className={styles.wordCount}>
              Word Count: {wordCount(responseItem.submittedValue)}
            </div>
          </div>
        ))}
        <Grid className={styles.rubricWrapper}>
          <Grid.Row className={styles.rubric}>
            {question.rubricItems.map((rubricItem) => (
              <Grid.Column className="col-lg-4 col-xxl-3" key={rubricItem.id}>
                <MarkItem
                  rubricItem={rubricItem}
                  // For CIPS Writing, there should only ever be one response item per question.
                  responseItemId={question.responseItems[0]?.id}
                  authorisableMark={authorisableMark}
                  defaultValues={defaultValues}
                />
              </Grid.Column>
            ))}
          </Grid.Row>
        </Grid>
      </div>
    </div>
  );
}
